<template>
    <div class="productPage">
        <div class="container">
            <el-tabs v-model="activeName" class="tabs">
                <el-tab-pane :label="item.name" :name="item.name" v-for="item in productOptions" :key="item.name">
                    <div class="product_list">
                        <div
                            v-for="product in item.children"
                            :key="product.name"
                            class="product_list_item"
                            @click="setCurrentProduct(product)"
                        >
                            <p>{{ product.name }}</p>
                            <img :src="product.img" alt="" />
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <div class="product_details">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="product-viewer">
                            <!-- <swiper :options="mainSwiperOptions" ref="mainSwiper" class="main-swiper">
                                <swiper-slide v-for="(image, index) in currentProduct.childrenImages" :key="index">
                                    <img :src="image" alt="Product Image" />
                                </swiper-slide>
                                <div class="swiper-button-prev" slot="button-prev"></div>
                                <div class="swiper-button-next" slot="button-next"></div>
                            </swiper>

                            <swiper :options="thumbSwiperOptions" ref="thumbSwiper" class="thumbs-swiper">
                                <swiper-slide
                                    v-for="(image, index) in currentProduct.childrenImages"
                                    :key="index"
                                    @click.native="goToSlide(index)"
                                >
                                    <img :src="image" alt="Thumbnail Image" class="thumbnail" />
                                </swiper-slide>
                            </swiper> -->
                            <!-- 主Swiper -->
                            <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
                                <swiper-slide v-for="(slide, index) in currentProduct.childrenImages" :key="index">
                                    <img :src="slide" alt="Main Slide" />
                                </swiper-slide>
                            </swiper>

                            <!-- 缩略图Swiper -->
                            <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">
                                <swiper-slide v-for="(slide, index) in currentProduct.childrenImages" :key="index">
                                    <img :src="slide" alt="Thumbnail Slide" />
                                </swiper-slide>
                            </swiper>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="product_details_name">{{ currentProduct.name }}</div>
                        <el-button round plain class="product_details_button" @click="openTechnicalParameterVisible"
                            >{{lang.technicalParameter}}</el-button
                        >
                        <el-button round plain class="product_details_button" @click="showDownLoadListVisible = true"
                            >{{ lang.downLoadDetail}}</el-button
                        >
                    </div>
                </div>
            </div>
        </div>
        <TechnicalParameter v-model="showTechnicalParameterVisible" :id="currentProduct.name"></TechnicalParameter>
        <DownLoadList v-model="showDownLoadListVisible" :id="currentProduct.name"></DownLoadList>
    </div>
</template>
<script>
import TechnicalParameter from "../components/technicalParameter.vue";
import DownLoadList from "../components/downLoadList.vue";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
export default {
    mixins: [],
    name: "productPage",
    components: {
        TechnicalParameter,
        DownLoadList,
        Swiper,
        SwiperSlide,
    },
    computed: {
        lang() {
            return this.$store.state.language;
        },
    },
    data() {
        return {
            swiperOptionTop: {
                loop: true,
                loopedSlides: 5, // looped slides should be the same
                spaceBetween: 10,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            },
            swiperOptionThumbs: {
                loop: true,
                loopedSlides: 5, // looped slides should be the same
                spaceBetween: 10,
                centeredSlides: true,
                slidesPerView: "auto",
                touchRatio: 0.2,
                slideToClickedSlide: true,
            },
            activeName: "SCORPIO",
            productOptions: [
                {
                    name: "SCORPIO",
                    children: [
                        {
                            name: "SCORPIO4",
                            img: "images/SCORPIO/main.jpg",
                            des: "超级无敌神奇飞机SCORPIO4",
                            childrenImages: [
                                "images/SCORPIO/1.jpg",
                                "images/SCORPIO/2.jpg",
                                "images/SCORPIO/3.jpg",
                                "images/SCORPIO/4.jpg",
                                "images/SCORPIO/5.jpg",
                                "images/SCORPIO/6.jpg",
                                "images/SCORPIO/7.jpg",
                                "images/SCORPIO/8.jpg",
                            ],
                        },
                        {
                            name: "SCORPIO3",
                            img: "images/SCORPIO/main.jpg",
                            des: "超级无敌神奇飞机SCORPIO3",
                            childrenImages: [
                                "images/SCORPIO/1.jpg",
                                "images/SCORPIO/2.jpg",
                                "images/SCORPIO/3.jpg",
                                "images/SCORPIO/4.jpg",
                                "images/SCORPIO/5.jpg",
                                "images/SCORPIO/6.jpg",
                                "images/SCORPIO/7.jpg",
                                "images/SCORPIO/8.jpg",
                            ],
                        },
                    ],
                },
                {
                    name: "LIBRA",
                    children: [
                        {
                            name: "LIBRA4",
                            des: "超级无敌神奇飞机LIBRA4",
                            img: "images/LIBRA/1.png",
                            childrenImages: [
                                "images/LIBRA/1.png",
                                "images/LIBRA/2.png",
                                "images/LIBRA/3.png",
                                "images/LIBRA/4.png",
                                "images/LIBRA/5.png",
                                "images/LIBRA/6.png",
                                "images/LIBRA/7.png",
                            ],
                        },
                        {
                            name: "LIBRA3",
                            des: "超级无敌神奇飞机LIBRA3",
                            img: "images/LIBRA/1.png",
                            childrenImages: [
                                "images/LIBRA/1.png",
                                "images/LIBRA/2.png",
                                "images/LIBRA/3.png",
                                "images/LIBRA/4.png",
                                "images/LIBRA/5.png",
                                "images/LIBRA/6.png",
                                "images/LIBRA/7.png",
                            ],
                        },
                        {
                            name: "LIBRA2",
                            des: "超级无敌神奇飞机LIBRA2",
                            img: "images/LIBRA/1.png",
                            childrenImages: [
                                "images/LIBRA/1.png",
                                "images/LIBRA/2.png",
                                "images/LIBRA/3.png",
                                "images/LIBRA/4.png",
                                "images/LIBRA/5.png",
                                "images/LIBRA/6.png",
                                "images/LIBRA/7.png",
                            ],
                        },
                    ],
                },
                {
                    name: "GEMINI40T",
                    children: [
                        {
                            name: "GEMINI40T",
                            img: "images/GEMINI40T/1.jpg",
                            des: "超级无敌神奇飞机GEMINI40T",
                            childrenImages: [
                                "images/GEMINI40T/1.jpg",
                                "images/GEMINI40T/2.jpg",
                                "images/GEMINI40T/3.jpg",
                                "images/GEMINI40T/4.jpg",
                                "images/GEMINI40T/5.jpg",
                            ],
                        }
                    ],
                },
            ],
            currentProduct: {},
            showTechnicalParameterVisible: false,
            showDownLoadListVisible: false,
        };
    },
    watch: {
        "$route.params.id": {
            handler(id) {
                let currentProductStr = id;
                let foundProduct = false;
                
                // Find the product and update the tab
                this.productOptions.forEach((item) => {
                    item.children.forEach((el) => {
                        if (el.name === currentProductStr) {
                            this.currentProduct = el;
                            this.activeName = item.name; // Set the active tab to match the product category
                            foundProduct = true;
                        }
                    });
                });
                
                if (!foundProduct) {
                    this.currentProduct = this.productOptions[0].children[0];
                    this.activeName = this.productOptions[0].name;
                }
                
                // Reinitialize swiper if needed
                this.$nextTick(() => {
                    if (this.$refs.swiperTop && this.$refs.swiperTop.$swiper) {
                        const swiperTop = this.$refs.swiperTop.$swiper;
                        const swiperThumbs = this.$refs.swiperThumbs.$swiper;
                        swiperTop.update();
                        swiperThumbs.update();
                        swiperTop.controller.control = swiperThumbs;
                        swiperThumbs.controller.control = swiperTop;
                    }
                });
            },
            immediate: true,
        },
    },
    created() {},
    async beforeMount() {},
    mounted() {
        this.$nextTick(() => {
            if (this.$refs.swiperTop && this.$refs.swiperTop.$swiper) {
                const swiperTop = this.$refs.swiperTop.$swiper;
                const swiperThumbs = this.$refs.swiperThumbs.$swiper;
                swiperTop.controller.control = swiperThumbs;
                swiperThumbs.controller.control = swiperTop;
            }
        });
    },
    methods: {
        setCurrentProduct(product) {
            this.$router.push(`/main/product/${product.name}`);
        },
        openTechnicalParameterVisible() {
            this.showTechnicalParameterVisible = true;
        },
        onThumbnailClick(event) {
            const clickedIndex = this.$refs.thumbsSwiper.$swiper.clickedIndex;
            if (clickedIndex !== undefined) {
                this.$refs.mainSwiper.$swiper.slideTo(clickedIndex);
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.productPage {
    flex: 1;
    overflow: auto;
    background-color: #fafafa;
    padding-bottom: 60px;
    
    .container {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 20px;
    }
    
    .tabs {
        overflow: hidden;
        padding-top: 40px;
        margin-bottom: 30px;
        
        ::v-deep {
            .el-tabs__nav-scroll {
                display: flex;
                justify-content: center;
            }
            .el-tabs__item {
                font-size: 26px;
                font-weight: 500;
                color: #666;
                padding: 0 30px;
                transition: all 0.3s ease;
                
                &.is-active {
                    color: #333;
                    font-weight: 600;
                }
                
                &:hover {
                    color: #333;
                }
            }
            .el-tabs__active-bar {
                height: 3px;
                background-color: #333;
            }
            .el-tabs__header {
                margin: 0;
                border-bottom: 1px solid #eaeaea;
            }
        }
        
        .product_list {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            gap: 20px;
            padding: 40px 10px;
            
            .product_list_item {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                transition: all 0.3s ease;
                padding: 15px;
                border-radius: 8px;
                width: 160px;
                
                &:hover {
                    background-color: #f0f0f0;
                    transform: translateY(-5px);
                    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
                }
                
                p {
                    margin-bottom: 15px;
                    font-weight: 500;
                    font-size: 18px;
                }
                
                img {
                    width: 100px;
                    height: 100px;
                    object-fit: cover;
                    border-radius: 6px;
                }
            }
        }
    }
    
    .product_details {
        text-align: center;
        color: #333;
        padding: 50px 0;
        margin-top: 20px;
        border-top: 2px solid #eaeaea;
        border-bottom: 2px solid #eaeaea;
        background-color: #fff;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.03);
        
        .row {
            display: flex;
            flex-wrap: wrap;
            margin: 0 -15px;
            
            .col-lg-6 {
                width: 50%;
                padding: 0 15px;
                
                @media (max-width: 992px) {
                    width: 100%;
                    margin-bottom: 30px;
                }
            }
        }
        
        .product_details_name {
            font-size: 56px;
            padding: 10px 0;
            line-height: 1.2;
            font-weight: 700;
            margin-bottom: 20px;
            background: linear-gradient(135deg, #333 0%, #666 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
        
        .product_details_button {
            margin: 10px;
            width: 220px;
            height: 54px;
            font-size: 18px;
            font-weight: 600;
            border-radius: 27px;
            border: 2px solid #333;
            color: #333;
            transition: all 0.3s ease;
            
            &:hover {
                background-color: #333;
                color: #fff;
            }
        }
        
        .product-viewer {
            width: 100%;
            
            .swiper {
                &.gallery-top {
                    width: 100%;
                    border-radius: 10px;
                    overflow: hidden;
                    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
                    
                    img {
                        width: 100%;
                        height: 450px;
                        object-fit: contain;
                        cursor: pointer;
                        background-color: #fff;
                    }
                    
                    .swiper-button-prev,
                    .swiper-button-next {
                        color: #333;
                        &:after {
                            font-size: 24px;
                            font-weight: bold;
                        }
                    }
                }
                
                &.gallery-thumbs {
                    box-sizing: border-box;
                    padding: 30px 0;
                    
                    img {
                        width: 100%;
                        height: 100px;
                        object-fit: contain;
                        cursor: pointer;
                        border-radius: 6px;
                        border: 2px solid transparent;
                        transition: all 0.3s ease;
                    }
                    
                    .swiper-slide {
                        width: 25%;
                        height: 100%;
                        opacity: 0.6;
                        transition: all 0.3s ease;
                        
                        &:hover {
                            opacity: 0.8;
                        }
                    }
                    
                    .swiper-slide-active {
                        opacity: 1;
                        
                        img {
                            border-color: #333;
                        }
                    }
                }
            }
        }
    }
    
    @media (max-width: 768px) {
        .tabs {
            ::v-deep {
                .el-tabs__item {
                    font-size: 20px;
                    padding: 0 15px;
                }
            }
            
            .product_list {
                gap: 10px;
                padding: 30px 5px;
                
                .product_list_item {
                    width: calc(50% - 10px);
                    padding: 10px;
                    
                    p {
                        font-size: 16px;
                        margin-bottom: 10px;
                    }
                    
                    img {
                        width: 80px;
                        height: 80px;
                    }
                }
            }
        }
        
        .product_details {
            .product_details_name {
                font-size: 42px;
            }
            
            .product-viewer {
                .swiper.gallery-top img {
                    height: 350px;
                }
            }
        }
    }
    
    @media (max-width: 576px) {
        .tabs {
            ::v-deep {
                .el-tabs__item {
                    font-size: 18px;
                    padding: 0 10px;
                }
            }
            
            .product_list {
                gap: 8px;
                
                .product_list_item {
                    width: calc(33.33% - 8px);
                    padding: 8px;
                    
                    p {
                        font-size: 14px;
                        margin-bottom: 8px;
                    }
                    
                    img {
                        width: 60px;
                        height: 60px;
                    }
                }
            }
        }
        
        .product_details {
            .product_details_name {
                font-size: 32px;
            }
            
            .product_details_button {
                width: 180px;
                height: 48px;
                font-size: 16px;
            }
            
            .product-viewer {
                .swiper.gallery-top img {
                    height: 280px;
                }
                
                .swiper.gallery-thumbs img {
                    height: 80px;
                }
            }
        }
    }
}
</style>
